<template>
    <article>
        <div class="table_card mb-5" v-if="show_form">
            <div class="table_card__head">
                <p class="table_card__head--title">
                Completar Registro
                </p>
            </div>
            <div class="table_card__body">
                <v-layout row wrap>
                    <v-flex xs12 lg12 class="pr-6">
                        <label
                        class="table_card__info--label"
                        :class="{ 'custom_input__title--colapsed': password != '' }"
                        >
                        Contraseña:
                        </label>
                        <input
                        name="contraseña"
                        class="faccess_input"
                        :class="{ 'custom_input__inputs--open': password != '' }"
                        v-validate="'required|alpha_num|min:6'"
                        type="password"
                        v-model="password"
                        ref="password"
                        />
                        <span style="color:red; font-size:12px" v-show="errors.has('contraseña')" class="showError">{{ errors.first('contraseña') }}</span>
                    </v-flex>
                    <v-flex xs12 lg12 class="pl-6">
                        <label
                        class="table_card__info--label"
                        :class="{ 'custom_input__title--colapsed': password_confirmation != '' }"
                        >
                        Confirmar Contraseña:
                        </label>
                        <input
                        name="confirmar contraseña"
                        class="faccess_input"
                        :class="{ 'custom_input__inputs--open': password_confirmation != '' }"
                        v-validate="'required|alpha_num|min:6|confirmed:password'"
                        type="password"
                        v-model="password_confirmation"
                        />
                        <span style="color:red; font-size:12px" v-show="errors.has('confirmar contraseña')" class="showError">{{ errors.first('confirmar contraseña') }}</span>
                    </v-flex>
                    <v-flex xs12 lg12 class="pl-6">
                        <label
                        class="table_card__info--label"
                        :class="{ 'custom_input__title--colapsed': password_confirmation != '' }"
                        >
                        Definir Pin de Respaldo:
                        </label>
                        <input
                        class="faccess_input"
                        :class="{ 'custom_input__inputs--open': access_pin != '' }"
                        maxlength="4"
                        type="text"
                        v-model="access_pin"
                        @keypress="onlyNumber"
                        />
                    </v-flex>
                    <v-flex xs12 class="pl-6">
                        <button
                            class="faccess_button"
                            @click="saveData()"
                            :disabled="!valid"
                        >
                            Guardar
                        </button>
                    </v-flex>
                </v-layout>
            </div>
        </div>

        <div class="table_card" v-else>
            <div class="table_card__head">
                <p class="table_card__head--title">
                Actualización Completada
                </p>
            </div>
            <div class="table_card__body">
                Has finalizado satisfactoriamente el proceso de registro, 
                ahora puedes ingresar en la aplicación móvil con la nueva contraseña que acabas de asignar.
            </div>
            <div class="table_card__footer">
                <p>Ya puedes cerrar esta pestaña en tu navegador.</p>
            </div>
        </div>
    </article>
</template>
<script>
export default {
    data(){
        return{
            show_form: true,
            email: '',
            password: '',
            password_confirmation: '',
            access_pin: '',
            valid_passwords: false,
            valid_pin: false,
            valid: false
        }
    },
    mounted(){
        this.updateLoader(false)
    },
    methods:{
        onlyNumber ($event) {
            let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
            if ((keyCode < 48 || keyCode > 57)) {
                $event.preventDefault();
            }
        },
        validateForm(){
            if(this.valid_passwords && this.valid_pin){
                this.valid = true;
            }else{
                this.valid = false;
            }
        },
        saveData(){            
            if (this.getDeviceId() === '' || this.getDeviceId() === null || this.getDeviceId() === 'null'){
                this.buildDeviceId()
            }
            var data = {
                user_id: this.getUserId(),
                password: this.password,
                password_confirmation: this.password_confirmation,
                access_pin: this.access_pin
            }
            try {
                this.$http.post("users/save_user_data", 
                    {data: this.encrypt(data).toString()},
                    {headers: {
                        "X-Device-ID": this.getDeviceId(),
                        Authorization: "Bearer " + this.getUserToken()
                    }                    
                }).then(function(response) {                    
                    if (response.body.meta != undefined && response.body.meta != null) {
                        if (response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null) {
                            this.checkToken(response.body.meta.authentication_token);
                        }
                    }
                    if (response.body && response.status == 201) {
                        this.show_form = false;
                    }
                },
                function(response) {
                        if (response.body.meta != undefined && response.body.meta != null) {
                            if (response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null) {
                                this.checkToken(response.body.meta.authentication_token);
                            }
                        }
                        if (response.status === 402) {
                            this.show_form = true;
                            this.updateAlertMessage(response.body.ans);
                            this.updateIsInAlert(true);
                        }
                    }
                );
            } catch (e) {
                this.updateAlertMessage(e.message);
                this.updateIsInAlert(true);
            }
        }
    },
    watch:{
        password(){
            if(this.password != '' && this.password.length > 5){
                this.valid_passwords = true        
            }else{
                this.valid_passwords = false        
            }
            this.validateForm()
        },
        password_confirmation(){
            if(this.password_confirmation != '' && this.password_confirmation.length > 5){
                this.valid_passwords = true        
            }else{
                this.valid_passwords = false        
            }
            this.validateForm()
        },
        access_pin(){
            if(this.access_pin != '' && this.access_pin.length === 4){
                this.valid_pin = true
            }else{
                this.valid_pin = false
            }
            this.validateForm()
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/views/users/CompleteRegistration.vue